import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { CalendarClock, Download } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });

export const AutoBackupList = () => {
  const [data, setData] = useState({ auto: [], last: null, safety: [] });
  useEffect(() => { api.get("/backup/list").then((r) => setData(r.data)); }, []);

  return (
    <section className="mt-5 rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-6" data-testid="auto-backup-card">
      <div className="flex items-center gap-2 mb-1">
        <CalendarClock className="w-5 h-5 text-[#B45309]" />
        <h2 className="font-display text-xl font-bold uppercase tracking-tight">Otomatik Yedekler</h2>
      </div>
      <p className="text-sm text-[#6B5B4A] mb-4">Her akşam 20:00'de kendiliğinden alınır, son 7 yedek saklanır.
        {data.last && <> Son yedek: <b data-testid="last-backup-time">{fmt(data.last.created_at)}</b> ({data.last.kind === "auto" ? "otomatik" : "elle"})</>}
      </p>
      {data.auto.length === 0 ? (
        <p className="text-sm text-[#8C7B68]" data-testid="auto-backup-empty">Henüz otomatik yedek yok. İlk yedek bu akşam 20:00'de alınacak.</p>
      ) : (
        <div className="divide-y divide-[#E8DDCA]" data-testid="auto-backup-list">
          {data.auto.map((b) => (
            <div key={b.id} className="flex items-center justify-between py-2.5" data-testid={`auto-backup-${b.id}`}>
              <div>
                <p className="text-sm font-medium">{fmt(b.created_at)}</p>
                <p className="text-[11px] font-mono text-[#8C7B68]">{b.filename} · {Math.max(1, Math.round(b.size / 1024))} KB</p>
              </div>
              <a href={`${API}/backup/auto/${b.id}`} data-testid={`auto-backup-download-${b.id}`}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-[#B45309] hover:text-[#78350F]">
                <Download className="w-4 h-4" /> İndir
              </a>
            </div>
          ))}
        </div>
      )}
      {data.safety?.length > 0 && (
        <div className="mt-5 pt-4 border-t border-[#E8DDCA]" data-testid="safety-backup-list">
          <p className="text-sm font-semibold mb-1">Güvenlik yedekleri</p>
          <p className="text-xs text-[#8C7B68] mb-2">Her geri yükleme ve eski kayıt temizliğinden hemen önce mevcut veriler buraya kaydedilir.</p>
          {data.safety.map((b) => (
            <div key={b.id} className="flex items-center justify-between py-2">
              <p className="text-sm">{fmt(b.created_at)}</p>
              <a href={`${API}/backup/auto/${b.id}`} data-testid={`safety-backup-download-${b.id}`}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-[#B45309]"><Download className="w-4 h-4" /> İndir</a>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
